import YesNoButton from '../YesNoButton/YesNoButton';
import iconVr from '../../assets/images/ubisoft-playtest-profile-icon-vr.webp';
import messages from './messages';
import { useIntl } from 'react-intl';
import { useState } from 'react';

interface Props {
  isInterested: boolean | null;
  setFieldValue: any;
  withHeader?: boolean;
  isSurvey?: boolean;
}

const VrTesting = ({
  isInterested,
  setFieldValue,
  withHeader = true,
  isSurvey = false
}: Props) => {
  const intl = useIntl();
  const [interested, setInterested] = useState(isInterested);

  return (
    <div className="vr-testing">
      {withHeader && (
        <div className="header">
          <img src={iconVr} alt="" className="mt-n1" />
          <h3>{intl.formatMessage({ ...messages.headerVrTesting })}</h3>
        </div>
      )}
      {isSurvey && (
        <div className="mt-3">
          <YesNoButton
            id="vrTesting"
            name="vrTesting"
            label={intl.formatMessage({ ...messages.vrTesting })}
            value={interested}
            onChange={(value: boolean) => {
              setInterested(value);
              setFieldValue('vrTesting', value);
            }}
          />
        </div>
      )}
      <div className="content">
        {!isSurvey && (
          <YesNoButton
            id="vrTesting"
            name="vrTesting"
            label={intl.formatMessage({ ...messages.vrTesting })}
            value={isInterested}
            onChange={(value: boolean) => {
              setFieldValue('vrTesting', value);
            }}
          />
        )}
      </div>
    </div>
  );
};

export default VrTesting;
